import { initApp } from '@app'
initApp().mount('#app')